var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-pages"},[_c(_vm.view,{tag:"component",on:{"close":_vm.cancelSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }